module.exports = __webpack_public_path__ + "img/thibault-photo.d34fcdf4.png";